import { Injectable } from '@angular/core';
import { Observable, of, Subscription, throwError } from 'rxjs';
import BaseService from 'libs/shared-lib1/src/lib/shared/base.service';
import { ConfigService } from 'libs/shared-lib1/src/lib/shared/services/config-service.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, delay, map, tap } from 'rxjs/operators';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {


  constructor(
    private baseService: BaseService,
    private configService: ConfigService,
    private http: HttpClient,
    //private recaptchaV3Service: ReCaptchaV3Service,
  ) { }

  verifyTheTokenOnServer(token: string, recaptchaThreshold: string = "", secretKey: string = ""): Observable<any> {
    {
      let retVal: any;

      let settings = this.configService;

      this.baseService.initializeBaseUrl(
        'https://localhost:7102',
        'https://itai-net-core.azurewebsites.net',
        settings
      );

      //https://codingsonata.com/google-recaptcha-v3-server-verification-in-asp-net-core-web-api/
      var urlForGet = this.baseService.baseUrl + '/api/test/verify-recaptcha?token=' + token + "&recaptchaThreshold=" + recaptchaThreshold + "&secretKey=" + secretKey;;
      
      var urlForPost = this.baseService.baseUrl + '/api/test/verify-recaptcha-post';

      debugger;
      //return this.http.post<Movie>(url, movie).pipe(
      //return this.http.get<any>(urlForGet).pipe(
      return this.http.post<any>(urlForPost, { "reCaptchaToken": token }).pipe(

        map((response: any) => {

          debugger;
          retVal = response;

          return retVal;

        }),
        catchError((error: any) => {

          //let errroAsString: string = error.message;

          //https://stackoverflow.com/questions/68655492/throwerrorerror-is-now-deprecated-but-there-is-no-new-errorhttperrorresponse
          return throwError(() => error);

        })

      );


    }

  }

  //WRAPPER for 2 calls - TODO - May be a bad idea
  // createAndVerifyRecaptcha(): Observable<any> {

  //   let retVal: any;

  //   let subscription: Subscription;

  //   subscription = this.recaptchaV3Service.execute('importantAction').subscribe(

  //     (token: string) => {

  //       // this.tokenVisible = true;
  //       // this.reCAPTCHAToken = `Token [${token}] generated`;
  //       let testMe = JSON.stringify(token);

  //       //POST TO VERIFY
  //       //https://developers.google.com/recaptcha/docs/verify
  //       //https://html.form.guide/snippets/google-recaptcha-javascript-validation/
  //       //https://codingsonata.com/google-recaptcha-v3-server-verification-in-asp-net-core-web-api/

  //       this.verifyTheTokenOnServer(token).subscribe(

  //         (reply: any) => {

  //           var reCaptchaResponse = reply.reCaptchaResponse;
  //           //alert("User recaptcha score: \n" + JSON.stringify(reCaptchaResponse, null, 2))
  //           return retVal;

  //         },
  //         (error: any) => {
            
  //           console.log(error)
  //           let errroAsString: string = error.message;

  //           //https://stackoverflow.com/questions/68655492/throwerrorerror-is-now-deprecated-but-there-is-no-new-errorhttperrorresponse
  //           return throwError(() => errroAsString);

  //         })
        
  //     },
  //     (error: any) => {

  //       console.log(error)
  //       let errroAsString: string = error.message;

  //       //https://stackoverflow.com/questions/68655492/throwerrorerror-is-now-deprecated-but-there-is-no-new-errorhttperrorresponse
  //       return throwError(() => errroAsString);
  //     },
  //     () => {
  //     }
  //   )
    
  //   return of();

  // }

}